import React, { useState } from 'react';

import { useEscapeToClose } from '../../hooks/useEscapeToClose';
function SendTrainerReportModal({ trainers, onClose, onSendReport }) {
  useEscapeToClose(onClose);   // Escape dismisses this modal
  const [selectedData, setSelectedData] = useState({
    bodyCharacteristics: true,
    healthObjectives: true,
    prescriptions: false,
    foodPreferences: true,
    dietPlans: true,
    mealPlans: true,
    exercisePlans: true,
    weightTrainingPlans: true,
    deviceData: true
  });

  const [selectedTrainers, setSelectedTrainers] = useState([]);

  const toggleTrainer = (trainerId) => {
    setSelectedTrainers(prev => {
      if (prev.includes(trainerId)) {
        return prev.filter(id => id !== trainerId);
      } else {
        return [...prev, trainerId];
      }
    });
  };

  const handleSend = () => {
    if (selectedTrainers.length === 0) {
      alert('Please select at least one trainer');
      return;
    }
    onSendReport(selectedData, selectedTrainers);
  };

  const DATA_ELEMENTS = [
    { key: 'bodyCharacteristics', label: 'Basic Body Characteristics', icon: '📊' },
    { key: 'healthObjectives', label: 'Health Objectives', icon: '🎯' },
    { key: 'prescriptions', label: 'Prescriptions / Supplements', icon: '💊' },
    { key: 'foodPreferences', label: 'Food Preferences', icon: '🥗' },
    { key: 'dietPlans', label: 'Diet Plans', icon: '📋' },
    { key: 'mealPlans', label: 'Meal Plans', icon: '🍽️' },
    { key: 'exercisePlans', label: 'Exercise Plans', icon: '🏃' },
    { key: 'weightTrainingPlans', label: 'Weight Training Plans', icon: '🏋️' },
    { key: 'deviceData', label: 'Device Data', icon: '📱' }
  ];

  return (
    <div className="modal-overlay">
      <div className="modal-content modal-content-lg">
        <div className="modal-header trm-gradientHeader">
          <h3>🏋️ Send Fitness Report to Trainers</h3>
          <button className="modal-close text-white" onClick={onClose}>&times;</button>
        </div>

        <div className="p-5">
          <p className="mb-20 text-gray-500">
            Choose which data elements you would like to include and then select which Trainers to send the report to. The report will be generated in PDF format and emailed to your selected trainers; you will be CC'd on this email. This email will include a 1-time passcode allowing your trainers to use a link included in the same email to add comments or recommendations.
          </p>

          {/* Section A: Data Elements */}
          <div className="mb-24">
            <h4 className="m-0-0-12-0 text-gray-700">
              A. Data Elements to Include
            </h4>
            <div className="data-element-grid">
              {DATA_ELEMENTS.map(({ key, label, icon }) => (
                <label key={key} className={`data-element-label ${selectedData[key] ? 'data-element-label-active' : ''}`}>
                  <input
                    type="checkbox"
                    checked={selectedData[key]}
                    onChange={(e) => setSelectedData(prev => ({
                      ...prev,
                      [key]: e.target.checked
                    }))}
                  />
                  <span>{icon} {label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Section B: Trainers to Receive */}
          <div className="mb-24">
            <h4 className="m-0-0-12-0 text-gray-700">
              B. Trainers to Receive
            </h4>
            <div className="trainer-select-grid">
              {trainers.map(trainer => (
                <label key={trainer.id} className={`trainer-label ${selectedTrainers.includes(trainer.id) ? 'trainer-label-active' : ''}`}>
                  <input
                    type="checkbox"
                    checked={selectedTrainers.includes(trainer.id)}
                    onChange={() => toggleTrainer(trainer.id)}
                  />
                  <div>
                    <div className="font-medium">{trainer.trainer_name}</div>
                    <div className="text-helper">
                      {trainer.trainer_type}
                      {trainer.trainer_certification && ` • ${trainer.trainer_certification}`}
                    </div>
                  </div>
                </label>
              ))}
            </div>
          </div>
        </div>
        <div className="p-16-24 border-t flex justify-end gap-12">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSend}
          >
            Generate & Send Report
          </button>
        </div>
      </div>
    </div>
  );
}

export default SendTrainerReportModal;
